import { useEffect, useRef, useState } from 'react';
import resourcesJson from '../../Content/Data/KnowledgeSection/ResourceMap.json';

function Resources(props) {

    const [files, setFiles] = useState(null);
    const previewContainerRef = useRef(null);
    const pdfViewerRef = useRef(null);
    const selectedResourceRef = useRef(null);

    useEffect(() => {
        loadData();
    }, [props.isPathChanged]);

    const loadData = async () => {
        try {
            let files = {};
            for (let i = 0; i < resourcesJson.Resources.length; i++) {
                const fileData = await import(`../../Content/Data/KnowledgeSection/Resources/${resourcesJson.Resources[i]["FullName"]}`);
                files = {
                    ...files,
                    [resourcesJson.Resources[i]["FileKey"]]: fileData.default
                };
            }
            setFiles(Object.keys(files).length ? files : false);
        } catch (error) {
            console.error("Failed to load resource files:", error);
        }
    };

    const handlePreview = (resource) => {
        selectedResourceRef.current = resource;
        pdfViewerRef.current.src = files[resource.FileKey] + "#toolbar=0";
        previewContainerRef.current.style.display = "block";
    };

    const handleClosePreview = () => {
        previewContainerRef.current.style.display = "none";
        pdfViewerRef.current.src = null;
        selectedResourceRef.current = null;
    }

    // const handleDownload = (resource) => {
    //     const a = document.createElement('a')
    //     a.href = files[resource.FileKey];
    //     a.download = resource.FullName
    //     document.body.appendChild(a)
    //     a.click()
    //     document.body.removeChild(a);
    // };

    return (
        <div className="resources">
            <div className="resource-container">
                <div className="resource-list-container">
                    {
                        resourcesJson.Resources.length ?
                            <table className='resource-list'>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left" }}>
                                            File Name
                                        </th>
                                        <th style={{ textAlign: "center" }}>
                                            Preview
                                        </th>
                                        {/* <th style={{ textAlign: "center" }}>
                                            Download
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        resourcesJson.Resources.map((resource, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "left" }}>
                                                        {resource.FileKey}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <i class="fa fa-eye pointer" aria-hidden="true" onClick={() => { handlePreview(resource); }}></i>
                                                    </td>
                                                    {/* <td style={{ textAlign: "center" }}>
                                                        {files && <i class="fa fa-download" aria-hidden="true" onClick={() => { handleDownload(resource); }} />}
                                                    </td> */}
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                            :
                            "No resources available."
                    }
                </div>
                <div className="resource-preview-container" ref={previewContainerRef}>
                    <div className='resource-preview-controls-contianer'>
                        {/* <i class="fa fa-download resource-preview-control pointer" aria-hidden="true" onClick={() => { handleDownload(); }} /> */}
                        <i class="fa fa-close resource-preview-control pointer" aria-hidden="true" onClick={() => { handleClosePreview(); }} />
                    </div>
                    <div className='resource-preview-viewer-container'>
                        <embed ref={pdfViewerRef} width="100%" height="100%" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Resources;
